// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"568273c4","453":"16836021","455":"8528a28c"}[chunkId] + ".chunk.js";
};